// @flow

import { extend, isObject, countBy, flatten } from 'lodash';

const safeExtend = (...args: Array<{}>) => {
  const saveKeys = [];
  const expectedKeyCount = args.reduce((prev, curr) => {
    if (isObject(curr)) {
      const keys = Object.keys(curr);
      saveKeys.push(keys);
      return keys.length + prev;
    }
    return prev;
  }, 0);
  const result = extend(...args);
  const resultKeyCount = Object.keys(result).length;
  if (resultKeyCount !== expectedKeyCount) {
    const counts = countBy(flatten(saveKeys), key => key);
    const collisionKeys = Object.keys(counts).filter(key => counts[key] > 1);
    throw new Error(
      'safeExtend expected no key collisions, but these keys collided: ' +
        collisionKeys.join(', ')
    );
  }
  return result;
};

export default safeExtend;
